<template>
    <div class="container">
        <div class="white-box mb-5 md:mb-7.5 md:px-16">
            <div class="px-7.5 pt-5">
                <h1 class="text-border mb-5 pb-5 font-medium text-black md:text-center">
                    請選擇行動電話號碼
                </h1>
                <div class="mb-5 text-lg text-gray-700 md:text-center">
                    系統將依您選擇的行動電話進行確認該行動電話為您本人所有。<br class="hidden md:inline">若客戶未成年，請選擇法定代理人行動電話。
                </div>
                <!-- existing start  -->
                <div class="flex flex-wrap">
                    <label class="input-label label mr-2.5 mb-1.5">
                        <span class="format-lg text-lg text-gray-800">
                            行動電話
                        </span>
                    </label>
                    <div class="w-full md:w-[200px]">
                        <Multiselect
                            v-model="mobileSelect"
                            :options="mobileList"
                            :can-clear="false"
                            :can-deselect="false"
                            mode="single"
                            placeholder="請選擇"
                            class="select-base"
                        />
                        <p class="error-msg text-right">
                            {{ errorMessage }}
                        </p>
                    </div>
                </div>
                <!-- existing end -->
            </div>
        </div>
        <div class="text-center">
            <button
                class="btn-primary btn"
                @click="checkData"
            >
                確認
            </button>
        </div>
    </div>
    <!-- 前往台通MID燈箱 -->
    <!-- <Modal
        v-model="state.checkModalVisible"
        @confirmed="checkConfirmed"
    >
        <template #content>
            本功能係富邦人壽委託臺灣網路認證股份有限公司，透過中華電信、台灣大哥大、台灣之星、亞太電信、遠傳電信五大電信公司4G/5G行動網路進行行動身分識別，請務必選擇自己申辦之行動電話進行驗證。
        </template>
    </Modal> -->
</template>
<script>
import { reactive, toRefs } from 'vue';
import { getMobileList, submitOTPMobile } from '@/apis/twid';
import Multiselect from '@vueform/multiselect';

export default {
    components: {
        Multiselect,
    },
    setup() {
        const data = reactive({
            mobileList: [],
            mobileSelect: '',
            errorMessage: ''
        });
        // const state = reactive({
        //     checkModalVisible: true,
        //     errorModalVisible: false,
        // });

        // 取得行動電話號碼
        const getMobile = () => {
            getMobileList().then(res => {
                console.log(res.data.mobileList);
                const resData = res.data;
                data.mobileList = [...resData.mobileList];
            });
        };
        getMobile();

        // 檢查電話
        const checkData = () => {
            if (data.mobileSelect === undefined || data.mobileSelect === '') {
                data.errorMessage = '請選擇行動電話';
                return;
            }
            submitOTPMobile(data.mobileSelect).then(res => {
                const resData = res.data;
                console.log('result' + resData.result);
                if (resData.result) {
                    const path = process.env.VUE_APP_API_PATH;
                    const baseUrl = `${window.location.origin}${path}`;
                    console.log(baseUrl + '/twid/redirect');
                    window.location.replace(baseUrl + '/twid/redirect');
                    data.errorMessage = '';
                } else {
                    // 要重抓一次電話 getMobile
                    data.errorMessage = '行動電話不正確';
                }
            });
        };

        // 台網認證燈箱確認觸發
        // const checkConfirmed = () => {
        //     window.location.replace(process.env.BASE_URL + '/twid/redirect');
        // };
        return {
            checkData,
            ...toRefs(data),
        };
    }
};
</script>
<style lang="postcss" scoped></style>
